import { cssClass } from '~src/style';

const cssPrefix = 'TableauGaiShared';
export namespace TableauGaiSharedStyles {

    // Right-aligns the button (e.g. Error Details) within an inline alert.
    // InlineAlertWidget lays the message and button out in a flex row; pushing
    // the button container's left margin to auto moves it to the alert's right edge.
    // The doubled '&&' selector raises specificity above the widget's own
    // '.buttonContainer' margin rule (equal specificity would otherwise let the
    // widget win depending on stylesheet source order).
    export const alertButtonRightAligned = cssClass(cssPrefix, 'alert-button-right-aligned', {
        $nest: {
            '&& .buttonContainer': {
                marginLeft: 'auto'
            }
        }
    });

}
